import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './ExperienceListItem.css';
import ExperienceListItemForm from './ExperienceListItemForm/ExperienceListItemForm';

class ExperienceListItem extends PureComponent {
  state = { editing: false };

  constructor(props) {
    super(props);
    this.changeEditionState = this.changeEditionState.bind(this);
  }

  render() {
    const { experience, handleUpdateExperience } = this.props;
    const { editing } = this.state;

    return editing ? (
      <ExperienceListItemForm
        experience={experience}
        changeEditionState={this.changeEditionState}
        handleUpdateExperience={handleUpdateExperience}
      />
    ) : (
      this.renderTextExperience(experience)
    );
  }

  changeEditionState() {
    this.setState(prev => ({ editing: !prev.editing }));
  }

  renderTextExperience(experience) {
    return (
      <div className="col-12">
        <div className="item-experiencer p-4">
          <p className="t-15">
            <span className="text-darkgreen">
              {`${experience.job_title}, ${experience.company_name}`}
            </span>
            <span
              className="text-dark-teal t-13 ml-2 cursor-pointer edit-experience-button"
              onClick={this.changeEditionState}
            >
              Edit
            </span>
          </p>
          <p className="text-gray-light t-12">{experience.job_description}</p>
        </div>
        <div className="row">
          <div className="col">
            <hr className="m-0" />
          </div>
        </div>
      </div>
    );
  }
}

ExperienceListItem.propTypes = {
  experience: PropTypes.object.isRequired,
  handleUpdateExperience: PropTypes.func,
};

export default ExperienceListItem;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/ExperienceList/ExperienceListItem/ExperienceListItem.js